import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Layout, Row, Col, Typography } from "antd";
import INELogo from "../../../assets/img/INELogo.svg";

const { Footer } = Layout;
const { Text, Link } = Typography;

export const FooterGeneral = () => {
  const { autenticado } = useSelector((state) => state.usuarioLogin);

  useEffect(() => {}, []);

  // const downloadIntegral = () => {
  //   //Code
  // };
  // const downloadSimplificado = () => {
  //   //Code
  // };

  return (
    <>
      <Footer style={{ background: "#333333" }}>
        <Row>
          <Col span={8}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={7} xxl={7}>
                <img src={INELogo} style={{ height: "30px" }} alt="INE" />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={17} xxl={17}>
                <Text style={{ color: "white" }}>
                  &copy; INE México {new Date().getFullYear()}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            {autenticado ? (
              <Row style={{ textAlign: "center" }}>
                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                  {/* <Link
                    underline
                    onClick={downloadIntegral}
                    target="_blank"
                    style={{ color: "white" }}
                  >
                    Aviso de Privacidad Integral
                  </Link> */}
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={112}>
                  {/* <Link
                    underline
                    onClick={downloadSimplificado}
                    target="_blank"
                    style={{ color: "white" }}
                  >
                    Aviso de Privacidad Simplificado
                  </Link> */}
                </Col>
              </Row>
            ) : (
              <div style={{ color: "#ffffff", textAlign: "center" }}>
                Unidad Tecnica de Servicios de Informática
              </div>
            )}
          </Col>
          <Col span={8} style={{ color: "#ffffff", textAlign: "right" }}>
            {autenticado ? (
              <>
                <Link
                  underline
                  href="https://cau.ine.mx/"
                  target="_blank"
                  style={{ color: "white" }}
                >
                  CAU
                </Link>
                <span style={{ color: "white", padding: "0px 5px 0px 5px" }}>
                  &#124;
                </span>
                <Text style={{ color: "white" }}>Versión del sistema 10.0</Text>
              </>
            ) : (
              <Text style={{ color: "white" }}>Versión 2.0</Text>
            )}
            <br />
            <Text style={{ color: "#333333" }}>1.3.0 Rev. 1, 12/12/2022 08:13:10</Text>
          </Col>
        </Row>
      </Footer>
    </>
  );
};
